"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["HAIRCUT"] = "haircut";
    ServiceType["OIL_CHANGE"] = "oil_change";
    ServiceType["SKATE_SHARPENING"] = "skate_sharpening";
    ServiceType["FINANCIAL"] = "financial";
    ServiceType["MASSAGE"] = "massage";
    ServiceType["CAR_WASH"] = "car_wash";
    ServiceType["LAUNDRY"] = "laundry";
    ServiceType["DRY_CLEAN"] = "dry_cleaning";
    ServiceType["YOGA"] = "yoga";
    ServiceType["FITNESS_CLASS"] = "fitness_class";
    ServiceType["COOKING_CLASS"] = "cooking_class";
    ServiceType["PHYSIOTHERAPY"] = "physiotherapy";
    ServiceType["DENTAL"] = "dental";
    ServiceType["CHIROPRACTIC"] = "chiropractic";
    ServiceType["OPTOMETRIST"] = "optometrist";
    ServiceType["ESTHETICIAN"] = "esthetician";
    ServiceType["TAX_PLANNING"] = "tax_planning";
    ServiceType["VETERINARIAN"] = "veterinarian";
    ServiceType["DOG_WALKING"] = "dog_walking";
    ServiceType["MAINTENANCE"] = "maintenance";
    ServiceType["PLUMBING"] = "plumbing";
    ServiceType["CLEANING"] = "cleaning";
    ServiceType["PERSONAL_SHOPPING"] = "personal_shopping";
    ServiceType["DIETITIAN"] = "dietitian";
    ServiceType["WELLNESS"] = "wellness";
    ServiceType["ASL_CLASS"] = "sign_language_class";
    ServiceType["MEDITATION"] = "meditation";
    ServiceType["CHEF_SERVICES"] = "chef_services";
    ServiceType["CHEF"] = "chef";
    ServiceType["YOGA_CLASSES"] = "yoga_classes";
    ServiceType["NAIL_TECH"] = "nail_tech";
    ServiceType["WINE_TASTING"] = "wine_tasting";
    ServiceType["ERGONOMICS"] = "ergonomics";
    ServiceType["FITNESS_YOGA"] = "fitness_yoga";
    ServiceType["PET_SERVICES"] = "pet_services";
    ServiceType["REFLEXOLOGY"] = "reflexology";
    ServiceType["REIKI"] = "reiki";
    ServiceType["WORKSHOP"] = "workshop";
    ServiceType["TIRE_SERVICES"] = "tire-services";
    ServiceType["AUTO_DETAILING"] = "auto-detailing";
    ServiceType["AUTO_MECHANIC"] = "auto-mechanic";
    ServiceType["FLU_CLINIC"] = "flu-clinic";
    ServiceType["PET_GROOMING"] = "pet-grooming";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
